import { Directive, Attribute, forwardRef } from '@angular/core';
import { NG_VALIDATORS, FormControl, Validator } from '@angular/forms';

@Directive({
  selector: '[validEquals][ngModel]',
  /* tslint:disable */
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => JbEqualValidator), multi: true}
  ]
  /* tslint:enable */
})
export class JbEqualValidator implements Validator {
  /* tslint:disable */
  constructor(@Attribute('validEquals') public validEquals: string) {
    /* tslint:enable */
  }

  public validate(c: FormControl): { [key: string]: any } {
    // self value (e.g. retype password)
    const v = c.value;

    // control value (e.g. password)
    const e = c.parent.get(this.validEquals);

    // value not equal
    if (e && v !== e.value) {
      return {
        validEquals: {
          valid: false
        }
      };
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/equal.validator.ts